import type {TextProps} from '@mantine/core';
import {Text} from '@mantine/core';
import type {FC} from 'react';

/**
 * Small dimmed helper/description text, rendered only when `text` is set.
 * @registry Dimmed helper text under a field/section, size xs by default.
 *
 * Ported from `library-m/data-display/Text/Description`. Prop surface kept
 * identical.
 */
export interface DescriptionProps extends TextProps {
  text?: string;
}

export const Description: FC<DescriptionProps> = ({
  text,
  size = 'xs',
  mt = 'sm',
  ...props
}) => {
  return (
    text ? (
      <Text mt={mt} size={size} c="dimmed" {...props}>
        {text}
      </Text>
    ) : null
  );
};
